/*============================*/
/* blog carousel. */
/*============================*/
var galleryID = "";
jQuery(document).ready(function($) {
  if ( !$('div[id*="enap-gallery"]').length || !$("#large-images-gallery").length) {return;}
  window.galleryID = $('div[id*="enap-gallery"]').eq(0).attr('id').split("-")[2];
  enapGeneratedCode = '<div id="enap-gallery-' + window.galleryID + '"></div><div id="enap-gallery-popup-' + window.galleryID + '"></div><script src="https://enormapps.com/gallery/embed.js" data-id="' + window.galleryID + '"></script>'
  $("#large-images-gallery").html(enapGeneratedCode);
});

jQuery(window).load(function(){
  if ( $('#shopify-section-article-template').length || $('#shopify-section-article-template-portrait').length ) {
    if ( $('#shopify-section-article-template-portrait').length ) {
      setPortrait();
    }

    // Create thumbnails:
    if ($('#enap-gallery-' + window.galleryID).html() != "") {
      createThumbnails()
    }
    else { // for Internet explorer, it doesn't work like Firefox and Crome so we haveto wait for the item to exist
      var checkThumbnailsInterval = setInterval(function() {
        if ($('#enap-gallery-' + window.galleryID).html() != "") {
          createThumbnails();
          clearInterval(checkThumbnailsInterval);
        }
      }, 200);
    }

    $('.galleries-section').show();
    var thumbnailsNumber = 14;

    $('.large-images-gallery .enap-gallery-img').each(function (index) {
      $(this).removeClass('enap-gallery-img');
    });

    if ( !$('#shopify-section-article-template-portrait').length ) {
      if ($(".enap-gallery > li").length) createArticleGallery();//{}//
      else {
        // for IE:
        var checkInterval = setInterval(function() {
          if ($(".enap-gallery > li").length) {
            $(".enap-gallery .enapgifloader").remove();
            $(".enap-gallery .enap-masonry-grid").remove();
            createArticleGallery()
            clearInterval(checkInterval);
          }
        }, 200);
      };
    }

    $("#shopify-section-article-template .rte p, #shopify-section-article-template-portrait .rte p").each(function () {
      if ($(this).html().indexOf("youtube") > -1) {
        $(this).insertAfter('.section-header');
        youtubeURL = $(this).html().replace("watch?v=", "embed/");
        $(this).replaceWith("<div class='embed-container'><iframe  width='420' height='315' src='" + youtubeURL + "' frameborder='0' allowfullscreen></iframe></div>")
      }
    });

  }

  function createThumbnails() {
    $("#thumbnails-images-gallery").html( $('#enap-gallery-' + window.galleryID).html() );
    fixIds($("#thumbnails-images-gallery"), 1); // Change the ID's of the gallery items brought to #thumbnails-images-gallery because these items already exist in #large-images-gallery because they use the same gallery

    $("#thumbnails-images-gallery1 li").each(function (index) {
      $(this).css("float", "none");
    });

    $('.enapgifloader').remove();
    $('.enap-masonry-grid').remove();

    $('.thumbnails-images-gallery .enap-gallery-img').each(function (index) {
      $(this).css("padding", "5px");
      $(this).css("list-style", "none");
      this.style.setProperty('width', "80px", 'important');
      $(this).css('height', "80px");

      $(this).find(".enap-img").first()[0].style.setProperty('height', "70px", 'important');
      $(this).click(function (e) {
        e.preventDefault();
        var inGalleryImgId = $(this)[0].id.slice(0,-1);
        var slickCorrespondentId = $('.large-images-gallery .enap-gallery #' + inGalleryImgId ).parent().parent().parent().index();

        $('.large-images-gallery .enap-gallery').slick('slickGoTo', $('#shopify-section-article-template-portrait').length ? slickCorrespondentId : $(this).index());
        if ($('#header-icons-mobile').css('display') == 'block') {
          $('html, body').animate({
            scrollTop: $(".large-images-gallery").first().offset().top - 60
          }, 750);
        }
      });

    });

  };

  function createArticleGallery() {
    //console.log("setPortrait:"+ $(".enap-gallery > li").length);

    $('.large-images-gallery .enap-gallery').slick({
      prevArrow: '<div class="slick-prev"><img src="//shop.urbanarmorgear.com/cdn/shop/t/78/assets/left-arrow-slide_small.png?v=95368386130258193901659710351"></div>',
      nextArrow: '<div class="slick-next"><img src="//shop.urbanarmorgear.com/cdn/shop/t/78/assets/right-arrow-slide_small.png?v=26071527858969365841659710645"></div>',

      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      fade: true,
      responsive: [
        {
          breakpoint: 768,
          settings: {
            arrows: false,
            dots: true
          }
        }
      ]
    });

    if ( $('#enap-gallery-mobile').length ) {
      $('#enap-gallery-mobile').slick({
        prevArrow: '<div class="slick-prev"><img src="//shop.urbanarmorgear.com/cdn/shop/t/78/assets/left-arrow-slide_small.png?v=95368386130258193901659710351"></div>',
        nextArrow: '<div class="slick-next"><img src="//shop.urbanarmorgear.com/cdn/shop/t/78/assets/right-arrow-slide_small.png?v=26071527858969365841659710645"></div>',

        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        fade: true,
        responsive: [
          {
            breakpoint: 768,
            settings: {
              arrows: false,
              dots: true
            }
          }
        ]
      });
    }
  }

  function setPortrait() {
    //wait for the items to exist for IE
    var checkInterval = setInterval(function() {
      if ($(".enap-gallery > li").length) {
        $(".enap-gallery > li").each(function () {
          listItemProportion( $( this ) );
        });
        clearInterval(checkInterval);
      }
    }, 200);
  }

  var wasUsedDoubleItem = false;
  var allListItems = 0;
  function createProportionsDivs() {
    allListItems = $(".large-images-gallery .enap-gallery > li").length;
    $("#large-images-gallery").append("<div id='enap-gallery-mobile'></div>");
    $(".large-images-gallery .enap-gallery > li").each(function (index) {
      var partOfDouble = $(this).attr("data-for-double") == "1";
      if (!partOfDouble) {
        $(this).parent().append('<div>' + $(this)[0].outerHTML + '</div>');
      }
      else {
        if (!wasUsedDoubleItem) {
          $(this).parent().append('<div' + (index === allListItems ? '' : ' class="is-doubled is-single"') + '>' + $(this)[0].outerHTML + '</div>');
        }
        else {
          var parentDoubled = $(this).parent().find(".is-doubled:last");
          $(this).clone().appendTo(parentDoubled);
          parentDoubled.removeClass("is-single");
        }
        wasUsedDoubleItem = !wasUsedDoubleItem;
      }
    });

    var doubledCompleted = false;
    $(".large-images-gallery .enap-gallery > li").each(function (index) {
      if ($(this).attr("data-for-double") == "1") {
        if (!doubledCompleted) {
          $(this).detach().appendTo('#enap-gallery-mobile');
        }
        else {
          //If a portrait image was moved to become part of a pair, the thumbnails should also be moved:
          var detachThumbnail = $("#thumbnails-images-gallery1 li:nth-child(" + (index+1) + ")");
          var lastDoubleIndex = $('#enap-gallery-mobile li[data-for-double="1"]:last').index();
          var attachAfterThumbnail = '#thumbnails-images-gallery1 li:nth-child(' + (lastDoubleIndex + 1) + ')';

          detachThumbnail.css("float","none");
          if (index - lastDoubleIndex >= 2) detachThumbnail.detach().insertAfter(attachAfterThumbnail);
          // End moving thumbnail

          $(this).detach().insertAfter('#enap-gallery-mobile li[data-for-double="1"]:last');
        }
        doubledCompleted = !doubledCompleted;
      }
      else $(this).detach().appendTo('#enap-gallery-mobile');
    });

    createArticleGallery();
  }

  var allProportionsAdded = 0;
  function proportionAdded() {
    allProportionsAdded++;
    if (allProportionsAdded == $(".enap-gallery > li").length)  createProportionsDivs();
  };

  var getBackgroundImageSize = function(el) {
    var imageUrl = $(el).css('background-image').match(/^url\(["']?(.+?)["']?\)$/);
    var dfd = new $.Deferred();

    if (imageUrl) {
      var image = new Image();
      image.onload = dfd.resolve;
      image.onerror = dfd.reject;
      image.src = imageUrl[1];
    } else {
      dfd.reject();
    }

    return dfd.then(function() {
      return { width: this.width, height: this.height };
    });
  };

  function listItemProportion( itemToCheck ) {
    var portraitMaxProportion = 4/5;
    getBackgroundImageSize(itemToCheck.find(".enap-img"))
      .then(function(size) {
        //console.log('Image size is', size.width, size.height);
        itemToCheck.find(".enap-img").closest( "li" ).attr("data-for-double", (size.width / size.height < portraitMaxProportion ) ? 1 : 0 );
        proportionAdded();
      })
      .fail(function() {
        //console.log('Could not get size because could not load image');
      });
  }

  function fixIds(elem, cntr) {
    $(elem).find("[id]").add(elem).each(function () {
      this.id = this.id + cntr;
    })
    $(elem).find("[data-id]").add(elem).each(function () {
      $(this).data("data-id", "111"+ cntr) ;
    })
  }

});